<template>
  <HrPageLayout
    title="Training Calendar"
    subtitle="View scheduled trainings and events"
    icon="📅"
    :breadcrumb-items="[
      { label: 'Dashboard', route: '/dashboard' },
      { label: 'Training & Development' },
      { label: 'Training Calendar' }
    ]"
  >
    <template #header-actions>
      <button type="button" class="hr-btn hr-btn-primary" @click="loadTrainings">
        <i class="bx bx-refresh" :class="{ 'bx-spin': loading }"></i> Refresh
      </button>
    </template>

    <div class="training-calendar-content">
      <div class="hr-chart-card hr-mb-4">
        <div class="hr-chart-body">
          <p class="hr-text-muted hr-mb-0">
            <i class="bx bx-info-circle"></i> Training calendar shows all available training programs. Schedule dates can be added in future updates.
          </p>
        </div>
      </div>

      <div class="hr-chart-card">
        <div class="hr-chart-header">
          <h5 class="hr-chart-title"><i class="bx bx-calendar-star"></i> Training Programs ({{ trainings.length }})</h5>
        </div>
        <div class="hr-chart-body">
          <div v-if="loading" class="hr-loading-wrap">
            <div class="hr-spinner"></div>
            <p class="hr-text-muted">Loading...</p>
          </div>
          <div v-else class="calendar-list">
            <div
              v-for="t in trainings"
              :key="t.trainingID"
              class="calendar-item"
            >
              <div class="calendar-item-icon">
                <i class="bx bx-book"></i>
              </div>
              <div class="calendar-item-body">
                <strong>{{ t.trainingName }}</strong>
                <span class="hr-badge hr-badge-info hr-ml-2">{{ t.trainingType }}</span>
                <p class="hr-text-muted hr-mb-0 hr-small">{{ t.trainingCode }} · {{ t.provider || '—' }} · {{ t.duration_days ? t.duration_days + ' days' : '' }} {{ t.duration_hours ? t.duration_hours + ' hrs' : '' }}</p>
              </div>
            </div>
            <div v-if="trainings.length === 0" class="hr-text-center hr-py-5 hr-text-muted">
              No training programs in the catalog yet.
            </div>
          </div>
        </div>
      </div>
    </div>
  </HrPageLayout>
</template>

<script>
/* eslint-disable */
import { authUrl, execute } from "@/api";
import HrPageLayout from "@/components/hrActions/HrPageLayout.vue";

export default {
  name: "TrainingCalendar",
  components: { HrPageLayout },
  data() {
    return { loading: false, trainings: [] };
  },
  mounted() {
    this.loadTrainings();
  },
  methods: {
    async loadTrainings() {
      this.loading = true;
      const data = new FormData();
      data.append("function", "getTrainings");
      try {
        const res = await execute(data, authUrl);
        const d = res?.data?.data;
        this.trainings = Array.isArray(d?.trainings) ? d.trainings : [];
      } catch (_) {
        this.trainings = [];
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.training-calendar-content { padding: 0; }
.calendar-list { display: flex; flex-direction: column; gap: 12px; }
.calendar-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding: 12px 16px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
}
.calendar-item-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: #059669;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.calendar-item-body { flex: 1; }
.hr-ml-2 { margin-left: 8px; }
.hr-small { font-size: 0.875rem; }
</style>
